<template>
    <div class="px-4 py-10 sm:px-6 lg:px-8 lg:py-14">
        <div class="md:grid md:grid-cols-2 md:items-center md:gap-12 xl:gap-32">
            <div>
                <img class="rounded-xl" :src="image" :alt="imageAlt" loading="lazy">
            </div>

            <div class="mt-5 sm:mt-10 lg:mt-0" :class="direction == 'right' ? '-order-1':''">
                <div class="space-y-6 sm:space-y-8">
                    <div class="space-y-2 md:space-y-4">
                        <h2 class="font-bold text-3xl lg:text-4xl text-gray-800">
                            {{ heading }}
                        </h2>
                        <!-- Builder rich text is authored HTML -->
                        <!-- eslint-disable-next-line vue/no-v-html -->
                        <div v-html="content" />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
defineProps({
    image: {
        type: String,
        required: true
    },
    imageAlt: {
        type: String,
        required: true
    },
    heading: {
        type: String,
        required: true
    },
    content: {
        type: String,
        required: true
    },
    direction: {
        type: String,
        required: true
    },
})
</script>